import {
  EntityAboutCard,
  EntityHasSubcomponentsCard,
  EntityLayout,
  EntityLinksCard,
  EntitySwitch,
  isKind,
} from '@backstage/plugin-catalog';

import { cloudAppPage } from './CloudAppPage';
import { groupPage } from './GroupPage';
import { userPage } from './UserPage';
import { cloudEnvPage } from './CloudEnvPage';
import { Grid } from '@material-ui/core';
import { entityWarningContent } from './EntityWarningContent';
import { EntityCatalogGraphCard } from '@backstage/plugin-catalog-graph';

const overviewContent = (
    <Grid container spacing={3} alignItems="stretch">
    {entityWarningContent}
    <Grid item md={6}>
      <EntityAboutCard variant="gridItem" />
    </Grid>
    <Grid item md={6} xs={12}>
      <EntityCatalogGraphCard variant="gridItem" height={400} relations={['fromOrg', 'hasApp']} kinds={['CloudApp', 'CloudCdn', 'CloudEnv', 'CloudOrg']} />
    </Grid>

    <Grid item md={4} xs={12}>
      <EntityLinksCard />
    </Grid>
    <Grid item md={8} xs={12}>
      <EntityHasSubcomponentsCard variant="gridItem" />
    </Grid>
  </Grid>
);

const defaultEntityPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      { overviewContent }
    </EntityLayout.Route>
  </EntityLayout>
);


export const entityPage = (
  <EntitySwitch>
    <EntitySwitch.Case if={isKind('CloudApp')} children={cloudAppPage} />    
    <EntitySwitch.Case if={isKind('CloudEnv')} children={cloudEnvPage} /> 
    <EntitySwitch.Case if={isKind('group')} children={groupPage} />
    <EntitySwitch.Case if={isKind('user')} children={userPage} />
    <EntitySwitch.Case>{defaultEntityPage}</EntitySwitch.Case>
  </EntitySwitch>
);
